import { TrendingUp, TrendingDown } from 'lucide-react';
import { cn } from '../lib/utils';
import { fmtDelta, fmtPercent, fmtMoney } from '../lib/api';

export function PriceDeltaBadge({ delta, deltaPercent, size = 'sm', showIcon = true, className }) {
    if (delta === null || delta === undefined) return null;
    const up = delta > 0;
    const zero = Number(delta) === 0;
    return (
        <span
            data-testid="price-delta-badge"
            className={cn(
                'inline-flex items-center gap-1 rounded-md border font-mono tabular-nums',
                size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
                zero
                    ? 'bg-muted/60 text-muted-foreground border-border'
                    : up
                    ? 'bg-[hsl(var(--price-increase-bg))] text-[hsl(var(--price-increase-fg))] border-[hsl(var(--price-increase-border))]'
                    : 'bg-[hsl(var(--price-decrease-bg))] text-[hsl(var(--price-decrease-fg))] border-[hsl(var(--price-decrease-border))]',
                className
            )}
        >
            {showIcon && !zero && (up ? <TrendingUp size={12} /> : <TrendingDown size={12} />)}
            <span>{fmtDelta(delta)}</span>
            {deltaPercent !== undefined && deltaPercent !== null && (
                <span className="opacity-80">({fmtPercent(deltaPercent)})</span>
            )}
        </span>
    );
}

export function OldNewPricePills({ oldPrice, newPrice, currency }) {
    return (
        <span className="inline-flex items-center gap-1.5">
            <span className="inline-flex items-center rounded-md border border-border bg-muted/60 text-muted-foreground px-2 py-0.5 text-xs font-mono tabular-nums">
                {fmtMoney(oldPrice, currency)}
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="inline-flex items-center rounded-md border border-border bg-card px-2 py-0.5 text-xs font-mono tabular-nums">
                {fmtMoney(newPrice, currency)}
            </span>
        </span>
    );
}
